export default __webpack_public_path__ + "static/media/A_Arvore.71e38091.mp3";